import "./App.css";
import AppRouter from "../router/AppRouter";
import { useRef, useState } from "react";
import { NewVersionSnackbar } from "../features/common-pages/NewVersionSnackbar";
import EnvironmentInfoSnackbar from "../features/common-pages/EnvironmentInfoSnackbar";
import { isNil, isEmpty } from "lodash";
import useNewVersion from "../shared/hooks/useNewVersion";

function App() {
  const [showSnackbar, setShowSnackbar] = useState(false);

  const reloadTimeoutRef = useRef<number | null>(null);

  useNewVersion({
    intervalMs: 2_000,
    onUpdate: () => {
      // Show a toast/banner first…
      setShowSnackbar(true);

      if (reloadTimeoutRef.current) {
        window.clearTimeout(reloadTimeoutRef.current);
      }
      reloadTimeoutRef.current = window.setTimeout(() => {
        window.location.reload();
      }, 10000);
    },
  });

  const isNullOrEmpty = (str: string) => isNil(str) || isEmpty(str);

  return (
    <>
      {showSnackbar && (
        <NewVersionSnackbar
          onReload={() => window.location.reload()}
          seconds={10}
        />
      )}

      {!isNullOrEmpty(window.config.ENVIRONMENT_NAME) && (
        <EnvironmentInfoSnackbar />
      )}


      <AppRouter showSnackbar={showSnackbar} />
    </>
  );
}

export default App;
